// extracted by mini-css-extract-plugin
export var layoutContainer = "_ct-0";
export var layoutContainerNoRounding = "_ct-6";
export var layoutContainerOpen = "_ct-5";
export var layoutContainerResizing = "_ct-1";
export var mainContent = "_ct-2";
export var resizeDivider = "_ct-3";
export var slidePanel = "_ct-4";